import React, { useEffect } from 'react';
import { useCountUp } from 'react-countup';

import Ellipse from 'src/components/elements/Ellipse';

import { motion } from 'framer-motion';

import styles from './Loader.scss';

type Props = {
  visible: boolean;
};

const Loader = ({ visible }: Props) => {
  const { countUp, update } = useCountUp({
    duration: 6,
    start: 0,
    end: 80,
  });

  useEffect(() => {
    if (!visible) {
      update(100);
    }
  }, [visible]);

  return (
    <motion.div
      key="loader"
      className={styles.loader}
      initial={{ scale: 0.5 }}
      animate={{ scale: 1, transition: { duration: 0.5 } }}
    >
      <Ellipse childrenClassNames={{ ellipse: styles.ellipse }} />
      <div className={styles.percentage}>{`${countUp}%`}</div>
    </motion.div>
  );
};

export default Loader;
